// extracted by mini-css-extract-plugin
export default {"tooltip":"_gsdzzIPCUo4Lk5QF2Wu"};